import { render, staticRenderFns } from "./CheckoutFailurePage.vue?vue&type=template&id=2b63c0f9&scoped=true&"
import script from "./CheckoutFailurePage.vue?vue&type=script&lang=js&"
export * from "./CheckoutFailurePage.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutFailurePage.vue?vue&type=style&index=0&id=2b63c0f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63c0f9",
  null
  
)

export default component.exports